import React, { useEffect, useState, useContext, useRef } from 'react'
// import { Redirect } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useQuery, useMutation, useLazyQuery } from '@apollo/react-hooks'
import { inject, observer } from 'mobx-react'
import {
  Button,
  Image,
  Card,
  Table,
  Empty,
  Typography,
  Switch,
  Modal,
  Popconfirm,
  Space,
  message
} from 'antd'
import {
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons'

import { toJS } from 'mobx'
import { nanoid } from 'nanoid'
import DataTableServices from '../../../../services/datatableServices'

// import SearchBoxItem from '../DataTools/SearchBoxItem'
import DataSelectModal from '../DataTools/DataSelectModal'
import DataNewItem from '../DataTools/DataNewItem'
import PrintLiveProducts from '../../../printer/Product/PrintLiveProducts'
import styled from 'styled-components'
import { EditableCell, EditableRow } from '../EditableCell'

import { colorByQuanity, removeVietnameseCharMark } from '../../../../ultils/datatableUtils'
import { imagePreset, build_search_by_column } from '../../../../ultils/datatableUtils'
const { Title } = Typography
const { Meta } = Card



const CorrectContainer = styled.div`
  width: 100%;
  overflow-y: 'auto';
  max-height: calc(100vh - 200px);
  padding: 0;
`

const CorrectProductPanel = ({
  usersStore,
  commonStore,
  liveStore,
  // onSave,
  onCancel,
  onSaveAll,
  tableId,
  history
}) => {
  const [codeSelect, setCodeSelect] = useState(false)

  const [showAddModal, setShowAddModal] = useState(false)
  const [showAddQuickModal, setShowAddQuickModal] = useState(false)
  const [selectedKeys, setSelectedKeys] = useState([])
  const [removeLoading, setRemoveLoading] = useState(false)
  const [saveLPLoading, setSaveLPLoading] = useState(false)
  // const [allSuggests, setAllSuggests] = useState(
  //   toJS(liveStore.suggestionCodes)
  // )
  // const [liveProducts, setLiveProducts] = useState(
  //   toJS(liveStore.liveProducts)
  // )
  const [somethingChanged, setSomethingChanged] = useState(false)

  const [codeChanged, setCodeChanged] = useState([])
  // function sort_code(a, b) {
  //   if (a.code < b.code) return -1
  //   if (a.code > b.code) return 1
  //   return 0
  // }


  const [createDatarow] = useMutation(DataTableServices.CREATE_DATAROW(), {
    errorPolicy: 'all',
    update(cache, { data }) {
    }
  })

  const [updateLiveProductsDeleted] = useMutation(
    DataTableServices.UPDATE_LIVE_PRODUCTS_DELETED(),
    {
      errorPolicy: 'all'
    }
  )

  const [updateManyDataRows] = useMutation(
    DataTableServices.UPDATE_MANY_ROWS(),
    {
      errorPolicy: 'all'
    }
  )


  useEffect(() => {
    // datatableStore.autoSelectValid()
    // console.log(`toJS(liveStore.suggestionCodes)`, toJS(liveStore.suggestionCodes))
    // console.log(`toJS(liveStore.liveProducts)`, toJS(liveStore.liveProducts))
    // setAllSuggests(toJS(liveStore.suggestionCodes))
    // setLiveProducts(toJS(liveStore.liveProducts))
    // setSomethingChanged(true)

    return () => {
      // setAllSuggests([])
      // setLiveProducts([])
      setCodeSelect(false)
      setSomethingChanged(false)
    }
  }, [])
  const closeCodeModal = () => {
    setCodeSelect(false)
  }


  useEffect(() => {
  }, [liveStore.liveProducts])

  const resetValidProduct = () => {

    // let newArr = [...allSuggests]
    // let liveArr = []
    // newArr.forEach((s, index) => {
    //   if (s.match_code) delete newArr[index].match_code
    //   if (s.qty_live) delete newArr[index].qty_live
    //   if (s.price_live) delete newArr[index].price_live
    //   // datatableStore.updateRefProduct(s.code, s.ref)
    // })
    // setAllSuggests(newArr)
    // setLiveProducts(liveArr)
    // setSomethingChanged(true)
  }

  const updateManyLiveProduct = async () => {
    setSaveLPLoading(true)
    let updateItems = liveStore.allUnsavedLiveProduct
    // console.log(`updateItems`, updateItems)
    // console.log(`updateItems`, updateItems)
    if (updateItems.length > 0) {
      // updateItems.forEach(item => {
      //   item.se = item.code + " " + removeVietnameseCharMark(item.customer?.name)
      // });
      let r = await updateManyDataRows({
        variables: {
          input: {
            data: {
              type: "rowkey",
              rows: toJS(updateItems)
            }
          }
        }
      })
      message.success(
        {
          content: `Đã đồng bộ ${updateItems.length} dữ liệu!`,
          key: 'saving'
        });
      // console.log('r', r)
      liveStore.allLPBeSaved()

    }
    setSaveLPLoading(false)
  }

  // const saveNewCode = cSelect => {
  //   if (!cSelect) return
  //   let liveArr = [...liveStore.liveProducts]
  //   let index = liveArr.findIndex(item => item.code === cSelect.code)
  //   liveArr[index].match_code = cSelect.ref.code
  //   liveArr[index].image = cSelect.ref.image
  //   liveArr[index].name = cSelect.ref.name
  //   if (!liveArr[index].price_live)
  //     liveArr[index].price_live = cSelect.ref?.price
  //   liveArr[index].ref = cSelect.ref.sid
  //   liveArr[index].key = cSelect.id
  //   liveStore.setLiveProducts(liveArr)
  //   setCodeSelect(false)
  //   setSomethingChanged(true)
  // }

  const onDeleteMainProduct = () => {
    if (!codeSelect.old_code) return
    let dupIndex = liveStore.liveProducts.findIndex(item => item.code === codeSelect.old_code)
    if (dupIndex > -1) {
      liveStore.liveProducts[dupIndex].ref = false
      delete liveStore.liveProducts[dupIndex].match_code
      liveStore.liveProducts[dupIndex].unsaved = true
    }
    setCodeSelect(false)
  }

  const changeMainProduct = async v => {
    if (!v.old_code) return
    // let sid = nanoid(10)
    let sid = false
    let dupIndex = liveStore.liveProducts.findIndex(item => item.code === v.old_code)
    let customers = []
    let qty_order = 0
    let qty_live = 0
    if (dupIndex > -1) {
      if (!liveStore.liveProducts[dupIndex].sid) {
        customers = liveStore.liveProducts[dupIndex].customers
        qty_order = liveStore.liveProducts[dupIndex].qty_order
        qty_live = liveStore.liveProducts[dupIndex].qty_live
      }
      else {
        sid = liveStore.liveProducts[dupIndex].sid
      }
      // else {
      // message.error('Mã đã được thêm vào!')
      // return
      // }
      // else {
      //   message.error('Mã đã được thêm vào!')
      //   return
      // }
    }

    if (v.ref) {
      qty_live = v.ref.qty_stock ? v.ref.qty_stock : 0
      if (v.ref.stock) {
        v.ref.stock.forEach(s => {
          if (!s.qty) s.qty = 1
          qty_live += parseInt(s.qty)
        });
      }
      if (!qty_live) qty_live = 0
      let newLiveProduct = {
        sid: sid,
        code: v.old_code,
        match_code: v.ref.code,
        edit_count: 0,
        name: v.ref?.name,
        image: v.ref?.image,
        ref: v.ref?.sid,
        qty_live: qty_live,
        price_live: v.ref.price,
        live_id: tableId,
        customers: customers,
        qty_order: qty_order
      }
      let se = build_search_by_column(newLiveProduct, [{ key: 'code' }, { key: 'match_code' }, { key: 'name' }])
      // if (dupIndex > -1) newLiveProduct.code = liveStore.liveProducts[dupIndex].code
      // console.log(`newLiveProduct`, newLiveProduct)

      if (!sid) {
        sid = nanoid(10)
        newLiveProduct.sid = sid
        newLiveProduct['ngay_tao'] = new Date()
        newLiveProduct['ngay_tao'] = newLiveProduct['ngay_tao'].toISOString()
        const input = {
          data: {
            datatable: '60b583bf198cc20014a6ecb6',
            row_data: newLiveProduct,
            rid: '60b583bf198cc20014a6ecb6' + '_' + sid,
            se: se
          },
        }
        var newRow = await createDatarow({
          variables: { input },
        })
        newRow = newRow?.data?.createDatarow?.datarow
        if (newRow) {
          newLiveProduct.key = newRow.id
          // setLiveProducts([...liveProducts, newLiveProduct])
          if (dupIndex > -1) {
            liveStore.liveProducts[dupIndex] = newLiveProduct
          }
          //  else {
          //   liveStore.setLiveProducts([newLiveProduct, ...liveStore.liveProducts])
          // }

        } else {
          message.error('Đã xảy ra lỗi! Xin hãy thử lại.')
        }
      } else {
        newLiveProduct.unsaved = true
        Object.assign(liveStore.liveProducts[dupIndex], newLiveProduct)
      }


      setCodeSelect(false)
      // console.log(`newLiveProduct`, newLiveProduct)
      // console.log(`newRow`, newRow)
      // if (!liveStore.liveProducts) liveStore.liveProducts = []
      // liveStore.liveProducts.push(newLiveProduct)

    }
  }

  const saveMainProduct = async v => {
    if (v.ref) {
      let liveQty = v.ref.qty_stock ? v.ref.qty_stock : 0
      if (v.ref.stock) {
        v.ref.stock.forEach(s => {
          if (!s.qty) s.qty = 1
          liveQty += parseInt(s.qty)
        });
      }
      if (!liveQty) liveQty = 0
      let sid = nanoid(10)

      let newLiveProduct = {
        sid: sid,
        code: v.ref.code,
        match_code: v.ref.code,
        edit_count: 0,
        name: v.ref?.name,
        image: v.ref?.image,
        ref: v.ref.sid,
        // ref: v.ref,
        qty_live: liveQty,
        price_live: v.ref.price,
        live_id: tableId,
        customers: [],
        qty_order: 0
      }

      // let se = false
      // if (newLiveProduct.code)
      //   se = newLiveProduct.code.toLowerCase() + ' '
      // if (newLiveProduct.name)
      //   se += removeVietnameseCharMark(newLiveProduct.name)
      let se = build_search_by_column(newLiveProduct, [{ key: 'code' }, { key: 'match_code' }, { key: 'name' }])

      newLiveProduct['ngay_tao'] = new Date()
      newLiveProduct['ngay_tao'] = newLiveProduct['ngay_tao'].toISOString()

      const input = {
        data: {
          datatable: '60b583bf198cc20014a6ecb6',
          row_data: newLiveProduct,
          rid: '60b583bf198cc20014a6ecb6' + '_' + sid,
          se: se
        },
      }
      var newRow = await createDatarow({
        variables: { input },
      })

      newRow = newRow?.data?.createDatarow?.datarow
      if (newRow) {
        newLiveProduct.key = newRow.id
        // setLiveProducts([...liveProducts, newLiveProduct])
        liveStore.setLiveProducts([newLiveProduct, ...liveStore.liveProducts])
      } else {
        message.error('Đã xảy ra lỗi! Xin hãy thử lại.')
      }

      setShowAddModal(false)
      // console.log(`newLiveProduct`, newLiveProduct)
      // console.log(`newRow`, newRow)
      // if (!liveStore.liveProducts) liveStore.liveProducts = []
      // liveStore.liveProducts.push(newLiveProduct)

    }
  }
  const saveProductLess = v => {
    if (v.status !== 'OK') {
      message.error('Đã xảy ra lỗi! Xin hãy thử lại.')
      return false
    }
    if (!v.data?.row_data?.code) return
    let dupIndex = liveStore.liveProducts.findIndex(item => item.code.toLowerCase() === v.data.row_data.code.toLowerCase())
    if (dupIndex > -1) {
      let customers = liveStore.liveProducts[dupIndex].customers
      let qty_order = liveStore.liveProducts[dupIndex].qty_order
      let qty_live = liveStore.liveProducts[dupIndex].qty_live

      let newLiveProduct = v?.data?.row_data
      if (!newLiveProduct.customers) newLiveProduct.customers = customers
      if (!newLiveProduct.qty_order) newLiveProduct.qty_order = qty_order
      if (!newLiveProduct.qty_live) newLiveProduct.qty_order = qty_live
      newLiveProduct.key = v?.data?.id
      liveStore.liveProducts[dupIndex] = newLiveProduct

    } else {
      let newLiveProduct = v?.data?.row_data
      newLiveProduct.key = v?.data?.id
      liveStore.setLiveProducts([newLiveProduct, ...liveStore.liveProducts])
    }
    // setShowAddQuickModal(false)  
  }

  const deleteMany = async (keys) => {
    let productsDeleted = liveStore.liveProducts.filter(item => {
      return keys.includes(item.key)
    })
    // console.log(`productsDeleted`, productsDeleted)
    let u = await updateLiveProductsDeleted({
      variables: {
        input: {
          data: {
            tableId: tableId,
            tableLiveProductsId: '60b583bf198cc20014a6ecb6',
            productsDeleted: productsDeleted
          }
        }
      }
    })
    let result = u.data.updateLiveProductsDeleted?.data
    // console.log(`result`, result)

    if (result?.status === "OK") {
      message.success(
        {
          content: `Xóa dữ liệu thành công!`,
          key: 'saving'
        });

      if (result?.codeDeleted) liveStore.setProductsDeleted(result.codeDeleted)
      if (result.remove_ids) {
        // let k = [...liveStore.liveProducts.filter(
        //   item => !result.remove_ids.includes(item.key)
        // )]
        // console.log(`k`, k)
        // liveStore.setLiveProducts(k)
        // console.log(`liveStore.liveProducts`, toJS(liveStore.liveProducts))
        liveStore.setLiveProducts(liveStore.liveProducts.filter(
          item => !result.remove_ids.includes(item.key)
        ))
      }
    } else {
      message.error(
        {
          content: "Có lỗi xảy ra!!"
        });
    }
  }

  // const saveAll = () => {
  //   // if (!somethingChanged) return
  //   // liveStore.setLiveProducts(liveProducts)
  //   // liveStore.setSuggestionCode(allSuggests)
  //   onSaveAll()
  //   codeChanged.forEach(code => {
  //     liveStore.reCalcCodeQty(code, false)
  //   });
  //   setCodeChanged([])
  //   // datatableStore.setSomethingUnsave(true)
  // }

  const CodeRender = (value, row, index) => {
    let cls = 'noProduct'
    // if (row.ref) cls = 'hasProduct'
    // if (datatableStore.refProduct[row.code]) cls = 'hasProduct'
    // if (liveStore.findRefProduct(row.code, row.match_code))
    //   cls = 'hasProduct'
    // console.log(`row`, row)

    // const liveIndex = liveStore.liveProducts.findIndex(
    //   item => item.code === row.code || item.match_code === row.code
    // )
    // if (liveIndex >= 0 && row.match_code) cls = 'inLive'

    if (row.key && row.sid) {
      if (row.ref) cls = 'sp-chinh'
      else cls = 'sp-le'
    }
    return (
      <div
        className="tagCode"
        onClick={() => {
          // setCodeSelect({ row, index })
          setCodeSelect({
            old_code: row.code,
            code: row.match_code ? row.match_code : row.code,
            index: index,
            ref: row.ref,
            sid: row.sid
          })
          // alert(row.code)
        }}
      >
        <span className={cls}>{row.code}</span>
      </div>
    )
  }

  const QuanityRender = (value, row, index) => {
    // return <div>{row.customers ? row.customers.length : 0}</div>
    return <div>{value}</div>


  }

  const UuTienRender = (value, row, index) => {
    if (!value) return '-'
    return value
  }


  const NameRender = (value, row, index) => {
    let name = row?.name
    // if (!name) name = liveStore.findRefProduct(row.code, row.match_code)?.name
    return (
      <div style={{ minWidth: 150 }}>
        { }
        {name ? name : '??'}
      </div>
    )
  }

  const liveEditSave = row => {
    const newData = [...liveStore.liveProducts]
    const index = newData.findIndex(item => row.code === item.code)
    const item = newData[index]
    if (row.price_live < 1000) row.price_live = row.price_live * 1000
    row.se = build_search_by_column(row, [{ key: 'code' }, { key: 'match_code' }, { key: 'name' }])
    row.unsaved = true
    newData.splice(index, 1, { ...item, ...row })
    // if (!codeChanged.includes(row.code))
    //   setCodeChanged(codeChanged => [...codeChanged, row.code])
    // liveStore.reCalcCodeQty(row.code, false)
    liveStore.setLiveProducts(newData)
  }

  const columns = [
    {
      title: 'Mã nhận',
      dataIndex: 'code',
      width: 90,
      render: CodeRender
    },
    {
      title: 'Mã khớp',
      dataIndex: 'match_code',
      width: 100,
      responsive: [
        'md', 'lg'
      ]
    },
    {
      title: 'Ảnh',
      dataIndex: 'image',
      width: 50,
      render: (value, row, index) => {
        // console.log(`row`, row)
        if (!value && row.image) value = row.image
        // let img = value ? value : '/no-image-40.jpg'
        let thumbnail = imagePreset(value, 'xsmall')
        // var s = ''
        // if (!row[c.dataIndex]) {
        //   var d = new Date(row.ngay_tao)
        //   s = `https://statics.tpos.vn/images/nhaiu/${d.getYear() - 100
        //     }${d.getMonth() + 1}${d.getDate()}/${two_digit(
        //       d.getUTCHours()
        //     )}${two_digit(d.getMinutes())}${two_digit(
        //       d.getSeconds()
        //     )}_product_${row.sid}.jpg?width=40&height=40`
        //   row[c.dataIndex] = s
        // } else {
        //   s = row[c.dataIndex]
        // }
        // return <Avatar shape="square" size="large" src={row[c.dataIndex]} />
        return <Image
          width={40}
          height={40}
          src={thumbnail}
          preview={{
            src: value,
          }}
        // src={row[c.dataIndex] ? row[c.dataIndex] : ""}
        // fallback="data:image/png;base64,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"
        />
        // return <Image width={40} height={40} src={img} />
      }
    },
    {
      title: 'Giá LIVE',
      editable: true,
      dataIndex: 'price_live',
      key: 'price_live',
      width: 90,
      onCell: record => ({
        record,
        inputType: 'number',
        editable: true,
        dataIndex: 'price_live',
        title: 'Giá LIVE',
        handleSave: liveEditSave
      }),
      render: (value, row) => {
        let price = '?'
        if (row.price_live) {
          if (isNaN(row.price_live)) return price
          price = parseInt(row.price_live)
          price = price / 1000
          price = price.toString() + ' k'
        }
        // price = row.price_live.toLocaleString('it-IT', {
        //   style: 'currency',
        //   currency: 'VND'
        // })
        return price
      }
    },
    {
      title: 'SL live',
      dataIndex: 'qty_live',
      key: 'qty_live',
      width: 60,
      align: 'center',
      editable: true,
      onCell: record => ({
        record,
        editable: true,
        inputType: 'number',
        dataIndex: 'qty_live',
        handleSave: liveEditSave
      }),
      render: (value, row) => {
        let qlive = row.qty_live ? row.qty_live : 0
        return <span style={{ fontWeight: "bold", color: colorByQuanity(qlive) }}>{qlive}</span>
      }
    },
    {
      title: 'Tên',
      dataIndex: 'name',
      key: 'name',
      width: 'auto',
      editable: true,
      render: NameRender,
      onCell: record => ({
        record,
        editable: true,
        inputType: 'text',
        dataIndex: 'name',
        handleSave: liveEditSave
      }),
    },
    {
      title: 'SL Đặt',
      dataIndex: 'qty_order',
      key: 'qty_order',
      width: 70,
      align: 'center',
      render: QuanityRender
    },
    {
      title: 'KH ưu tiên',
      dataIndex: 'kh_uutien',
      key: 'kh_uutien',
      width: 100,
      align: 'center',
      render: UuTienRender
    },

    // {
    //   title: 'Giá hệ thống',
    //   dataIndex: 'price',
    //   key: 'price',
    //   width: 100,
    //   render: (value, row) => {
    //     // let price = '-'
    //     let price = false

    //     if (row.ref)
    //       price = row.ref.price
    //     else
    //       price = liveStore.findRefProduct(row.code, row.match_code)?.price

    //     if (price)
    //       return price.toLocaleString('it-IT', {
    //         style: 'currency',
    //         currency: 'VND'
    //       })
    //     else return '-'
    //   }
    // },
    // {
    //   title: 'SL Hệ thống',
    //   dataIndex: 'qty',
    //   key: 'qty',
    //   width: 100,
    //   align: 'center',
    //   render: (value, row) => {
    //     // let qty = row?.ref?.quanity
    //     //  qty = liveStore.findRefProduct(row.code, row.match_code)?.so_luong
    //     return liveStore.findRefProduct(row.code, row.match_code)?.qty
    //     // return datatableStore.refProduct[row.code]?.so_luong
    //   }
    // }
  ]

  const TitleBar = () => {
    return (
      <>
        Sp live
        <Space style={{ marginLeft: 10 }}>
          {selectedKeys.length > 0 ?
            <Button loading={removeLoading} type="primary" danger size="small" icon={<DeleteOutlined />}
              onClick={async () => {
                setRemoveLoading(true)
                await deleteMany(selectedKeys)
                // const input = {
                //   data: {
                //     tableId: tableId,
                //     ids: selectedKeys
                //   }
                // }
                // let delReturn = await deleteManyRows({
                //   variables: { input }
                // })
                setRemoveLoading(false)
                // if (delReturn.data?.deleteManyDataRows?.data?.ok === 1) {
                //   datatableStore.resetFilter()
                // }
                setSelectedKeys([])
              }}
            >
              Xóa
            </Button>
            : ""
          }
          <Button
            type="link"
            size={'small'}
            icon={<PlusOutlined />}
            onClick={() => {
              setShowAddQuickModal(true)
              // console.log('comm  onStore.company', commonStore.company)
              // alert(commonStore.company.slug)
            }}
          >
            sp lẻ
          </Button>
          <Button
            type="link"
            size={'small'}
            icon={<PlusOutlined />}
            onClick={() => {
              setShowAddModal(true)
              // console.log('comm  onStore.company', commonStore.company)
              // alert(commonStore.company.slug)
            }}
          >
            sp chính
          </Button>
          <Button
            type="link"
            size={'small'}
            icon={<PlusOutlined />}
            onClick={() => {
              // setShowAddModal(true)
              // console.log('comm  onStore.company', commonStore.company)
              // alert(commonStore.company.slug)
            }}
          >
            sp nhóm
          </Button>
          {/* <Button
            type="link"
            size={'small'}
            icon={<UndoOutlined />}
            onClick={resetValidProduct}
          >
            Làm lại
          </Button> */}
        </Space>
      </>
    )
  }

  //   const MetaRender = ({ item }) => {
  //     let links = configs.baseUrl
  //     let uri = item.id
  //     return <Link to={links + uri}>{item[configs.titleColumn]}</Link>
  // }

  // const ProductItem = ({ row }) => {
  //   let name = row?.ref?.name
  //   if (!name) {
  //     let p = liveStore.findRefProduct(row.code, row.match_code)
  //     if (p) {
  //       name = p.name
  //     } else return ''
  //   }
  //   return (
  //     <Card bordered>
  //       <Meta
  //         avatar={
  //           <Avatar shape="circle">{name.charAt(0).toUpperCase()}</Avatar>
  //         }
  //         title={name}
  //         description={name}
  //       />
  //     </Card>
  //   )
  // }

  // console.log('detailData', detailData)
  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (srk) => {
      setSelectedKeys(srk)
    }
  };

  return (
    <Modal
      // style={{
      //   top: 20
      // }}
      width="90%"
      maskClosable={false}
      wrapClassName="correctProductModal"
      visible={true}
      centered
      title={<TitleBar />}
      // title="Các sản phẩm trong Live"
      onCancel={onCancel}
      footer={[
        <PrintLiveProducts title='In'
          printData={{
            items: toJS(liveStore.visibleLiveProducts),
            live_name: '?'
          }}
          columns={['image', 'code', 'qty_live', 'price_live', 'name']}
        />,
        <Button shape="round" key="back" onClick={onCancel}>
          Đóng
        </Button>,
        <Button
          type="primary"
          shape="round"
          onClick={updateManyLiveProduct}
          // disabled={liveStore.liveProducts.filter(item => item.unSaved).length < 1}
          disabled={liveStore.allUnsavedLiveProduct.length < 1}
          loading={saveLPLoading}
        >
          Lưu
        </Button>,

        // setSomethingChanged

        // <Button
        //   key="submit"
        //   type="primary"
        //   onClick={saveAll}
        //   disabled={!somethingChanged}
        // >
        //   Lưu
        // </Button>
      ]}
    >
      <CorrectContainer>
        <Table
          id="correctTable"
          components={{
            body: {
              row: EditableRow,
              cell: EditableCell
            }
          }}
          // style={{
          //   height: 'calc(100vh - 100px)',
          //   maxHeight: 'calc(100vh - 100px)',
          //   marginBottom: 10,
          //   border: '1px solid #fcfcfc'
          // }}
          // dataSource={liveStore.liveProducts}
          // dataSource={liveStore.liveProducts.filter(item => {
          //   if (!liveStore.productsDeleted) return true
          //   return !liveStore.productsDeleted.includes(item.code)
          // }
          // )}
          dataSource={liveStore.visibleLiveProducts}
          rowSelection={rowSelection}
          // dataSource={allSuggests}
          columns={columns}
          // scroll={{ y: 'calc(100vh - 235px)', scrollToFirstRowOnChange: true }}
          bordered
          size={'small'}
          pagination={false}
        />
        {codeSelect ? (
          <DataSelectModal
            title={'Chỉnh sửa mã'}
            searchColumns={['code', 'name']}
            displayColumns={['code', 'name', 'price']}
            initData={codeSelect}
            tableId="5fe7fb4d2136a764ac573c1e"
            closeOnSelect={true}
            onSave={changeMainProduct}
            // onSave={v => {
            //   // console.log('v', v)
            //   saveNewCode(v)
            // }}
            onClose={closeCodeModal}
            onDelete={onDeleteMainProduct}
            // component={ProductItem}
            onSearchSelect={(v, o) => {
              // console.log('oz', o)
            }}
          />
        ) : (
          ''
        )}

        {showAddModal ? (
          <DataSelectModal
            title={'Thêm'}
            searchColumns={['code', 'name']}
            displayColumns={['code', 'name', 'price']}
            tableId="5fe7fb4d2136a764ac573c1e"
            closeOnSelect={true}
            onSave={saveMainProduct}
            onClose={() => {
              setShowAddModal(false)
            }}
            // component={ProductItem}
            onSearchSelect={(v, o) => {
              // console.log('o', o)
            }}
          />
        ) : (
          ''
        )}

        {showAddQuickModal ?
          <DataNewItem
            title={'Sp lẻ'}
            table={'60b583bf198cc20014a6ecb6'}
            initData={{ qty_live: 1 }}
            quickCapture={true}
            extraData={
              { 'live_id': tableId }
            }
            buttonTop={true}
            onSave={saveProductLess}
            onClose={() => {
              setShowAddQuickModal(false)
            }}
            keepReset={true}
          />
          : ""
        }

      </CorrectContainer>
    </Modal>
  )
}

export default inject(
  'usersStore',
  'commonStore',
  'liveStore'
)(observer(CorrectProductPanel))
